import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import PackStatisticalInfo from '../entities/pack-statistical'
import appconst from '@/lib/appconst';


interface PackStatisticalInfoState extends ListState<PackStatisticalInfo> {
    PackStatisticalInfo: PackStatisticalInfo,
}

class PackStatisticalInfoMutations extends ListMutations<PackStatisticalInfo>{

}
class PackStatistical extends ListModule<PackStatisticalInfoState, any, PackStatisticalInfo>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<PackStatisticalInfo>(),
        loading: false,
        PackStatisticalInfo: PackStatisticalInfo,
        shopid: 0

    }
    actions = {
        async getAll(context: ActionContext<PackStatisticalInfoState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/StatisticalRecords/GetPackedPackNumsList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<PackStatisticalInfo>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
         
        },
    };
    mutations = {
        setCurrentPage(state: PackStatisticalInfoState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: PackStatisticalInfoState, pagesize: number) {
            state.pageSize = pagesize;
        },
        getImgUrl(state: PackStatisticalInfoState, data: any) {

            data.url = appconst.remoteServiceBaseUrl + "/api/services/app/AuthorizationShop/GetComeBackUrl";

        }

    }
}

const packstatistical = new PackStatistical();
export default packstatistical;